import classNames from 'classnames'
import { FieldValues, UseFormRegister } from 'react-hook-form'

import './BasicInput.scss'

interface BasicInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string
  inputWrapperClassName?: string
  unstyledInputWrapper?: boolean
  register?: UseFormRegister<FieldValues>
}

const BasicInput: React.FC<BasicInputProps> = ({
  name,
  inputWrapperClassName,
  unstyledInputWrapper = false,
  register = () => {},
  className,
  defaultValue,
  ...props
}) => {
  return (
    <div
      className={classNames(
        { ['basic-input-wrapper']: !unstyledInputWrapper },
        inputWrapperClassName,
      )}
    >
      <input
        id={name}
        name={name}
        className={classNames('basic-input', className)}
        aria-label={name}
        defaultValue={defaultValue}
        {...register(name)}
        {...props}
      />
    </div>
  )
}

export { BasicInput }
export type { BasicInputProps }
